import { createFileRoute, useRouterState } from '@tanstack/react-router';
import { lazy } from 'react';

const GetStarted = lazy(() => import('@/pages/GetStarted'));

export const Route = createFileRoute('/get-started')({
  component: GetStartedRoute,
});

function GetStartedRoute() {
  const carried = useRouterState({ select: (state) => state.location.state.raceChoice });
  return <GetStarted carried={carried} />;
}
